import {BaseModule} from './base.module';
import {DocumentLanguageModule} from './document-language.module';
import {StorageModule} from './storage.module';
import {TextToSpeechModule} from './text-to-speech.module';

/**
 * Speak, friend, and enter
 */
export class InternationalTextToSpeechModule extends TextToSpeechModule {

    language = 'en-US';

    constructor() {
        super();
    }

    handleInputFocus(event) {
        let placeholder = event.target.placeholder;
        let inputValue = ``;
        let labelText = ``;
        let inputType = ``;
        let p = `with placeholder ${placeholder}`;
        if (typeof placeholder !== 'undefined' && placeholder.length > 0) {
            placeholder = p;
        }
        if (
            typeof event.target !== 'undefined' &&
            typeof event.target.value !== 'undefined' &&
            typeof event.target.value.length > 0
        ) {
            inputValue = `the value is now ${event.target.value}`;
        }

        console.log('event.target.type', event.target.type);
        if (
            typeof event.target !== 'undefined' &&
            typeof event.target.type !== 'undefined'
        ) {
            let readableType = `${event.target.type}`;
            switch (event.target.type) {
                case 'email':
                    readableType = `e-mail`;
                    break;

                default:
                    break;
            }
            inputType = `of type ${readableType}`;
        }

        if (event.target.parentNode) {
            let label = event.target.parentNode.querySelector('label');
            if (label) {
                console.log('label...', label);
                labelText = `with label ${label.textContent}`;
            } else {
                labelText = event.target.parentNode.textContent;
            }
        }

        this.speak(`Input field ${inputType} ${labelText} ${placeholder}, ${inputValue}`);
    }

    handleElementFocus(event) {
        // console.log('focus-like event received', event);
        if (this.enabled == true) {
            window.speechSynthesis.cancel(); // cancel any already uttering voices
            console.log('enabled?', this.enabled);
            let elementType = 'element';
            let textContent = event.target.textContent;
            if (typeof event.target.localName !== 'undefined') {
                console.log('local name:', event.target.localName);
                switch (event.target.localName) {
                    case 'h1':
                    case 'h2':
                    case 'h3':
                    case 'h4':
                    case 'h5':
                    case 'h6':
                        elementType = 'Title';
                        break;
                    case 'p':
                        elementType = 'Paragraph';
                        // this.handleInputFocus(event);
                        // let closestInput = event.target.closest('input');
                        // if (closestInput) {
                        //     elementType = 'Eenvoudig invoerveld binnen paragraaf';
                        //     this.handleInputFocus(event);
                        // }
                        break;
                    case 'span':
                        elementType = 'Inline element';
                        break;
                    case 'blockquote':
                        elementType = 'Quote';
                        break;
                    case 'cite':
                        elementType = "Cited";
                    case 'ol':
                        elementType = "Ordered list";
                    case 'ul':
                        elementType = "Unordered list";
                        break;
                    case 'li':
                        elementType = "list item";
                        break;
                    case 'a':
                        elementType = 'Link';
                        break;
                    case 'button':
                        elementType = 'Button';
                        break;
                    case 'strong':
                        elementType = 'Important text';
                        break;
                    case 'small':
                        elementType = 'Small text';
                        break;
                    case 'img':
                        elementType = 'Image';
                        // alert('img');
                        break;
                    case 'input':
                        elementType = 'Simple input field';
                        this.handleInputFocus(event);
                        break;
                    case 'label':
                        elementType = 'Label';
                        break;
                    case 'svg':
                    case 'use':
                        elementType = 'Graphic';
                        let closestLink = event.target.closest('a');
                        if (closestLink && closestLink.hasAttribute('title') === true) {
                            this.speak(`The title of the graphic in this link is: ${closestLink.getAttribute('title')}. The link target is ${closestLink.href}`);
                        }
                        let queryTitle = event.target.querySelector('title');
                        console.log('queryTitle', queryTitle);
                        if (queryTitle) {
                            textContent = queryTitle.textContent;
                            this.speak(`A scalable image: ${textContent}`);
                        }
                        if (event.target.localName === 'use') {
                            queryTitle = event.target.parentNode.querySelector('title')
                            if (queryTitle) {
                                textContent = queryTitle.textContent;
                                this.speak(`A scalable image, the title is: "${textContent}"`);
                            }
                        }
                        break;

                }
            }
            if (typeof textContent !== 'undefined' && textContent.length > 0) {
                this.speak(`${elementType}: ${textContent}`);
            } else {
                this.speak(`${elementType}`);
            }
            if (event.target.localName == 'a' && typeof event.target.href !== 'undefined' && typeof event.target.href !== null) {
                let href = event.target.href;
                href.replace('.', ' punt ');
                href.replace('nl', 'NL');
                this.speak(`The link target is: ${href}`);
            }
            if (event.target.hasAttribute('title') && event.target.getAttribute('title').length > 0) {
                this.speak(`This element's title is: ${event.target.getAttribute('title')}`);
            }
            if (event.target.hasAttribute('alt') && event.target.getAttribute('alt').length > 0) {
                this.speak(`The alternative text for this item is: ${event.target.getAttribute('alt')}`);
            }
        }
    }

    introduce() {

        let introduced = this.storageModule.getItem('sessionStorage', 'introduced-text-to-speech-accessibility');

        console.log('introduced?', introduced);

        if (introduced == null) {
            this.speak(`Welcome to the accessibility view of website "${window.location.hostname}."`);
            if (this.touchCompatible == false) {
                // if no touchstart was triggered before, then announce a message about mouse & keyboard for TAB-nav
                this.speak(`Click elements to get more information about the elements`);
                this.speak(`Use key board navigation to navigate to buttons`);
            }
            if (this.touchCompatible == true) {
                this.speak(`Tap elements to get more information about the elements`);
            }
            this.speak(`If you would like to hear this explanation again, close all browser window sessions and go to this domain again`);
            this.speak(`An explanation about this page will start now`);
        }
        this.speak(`Page title: "${document.title}".`);
        if (window.location.pathname == '/') {
            this.speak(`You are on the home page of this website.`);
        }
        if (window.location.pathname.length > 1) {
            this.speak(`The sub-page is ${window.location.pathname}`);
        }
        let h1 = document.documentElement.querySelector('h1');
        let h2 = document.documentElement.querySelector('h2');
        let h3 = document.documentElement.querySelector('h3');
        let h4 = document.documentElement.querySelector('h4');
        let h5 = document.documentElement.querySelector('h5');
        let h6 = document.documentElement.querySelector('h6');
        if (h1) {
            this.speak(`The first important title is ${h1.textContent}`); // first things first,
        }
        if (h2) {
            this.speak(`The second important title is ${h2.textContent}`); // second things second,
        }
        if (h3) {
            this.speak(`The third important title is ${h3.textContent}`); // third things third,
        }
        if (h4) {
            this.speak(`The fourth important title is ${h4.textContent}`); // fourth things fourth,
        }
        if (h5) {
            this.speak(`The fifth important title is ${h5.textContent}`); // fifth things fifth,
        }
        if (h6) {
            this.speak(`The sixth important title is ${h6.textContent}`); // sixth things sixth,
        }
        // and you can count on yourself!

        this.storageModule.setItem('sessionStorage', 'introduced-text-to-speech-accessibility', true);
        console.log('introduced? after setting it', introduced);
    }
}
